module.exports = __webpack_public_path__ + "img/ico_error_search.ef3b98a4.svg";